import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const toastrService = inject(ToastrService);

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            console.error('HTTP request failed:', error);
            toastrService.error(getErrorMessage(error.status), 'Request Failed');
            return throwError(() => error);
        }),
    );
};

function getErrorMessage(status: number): string {
    switch (status) {
        case 401:
            return 'Your session expired. Please refresh and try again.';
        case 403:
            return "You don't have permission to perform this action.";
        case 500:
            return 'Server error. Please try again later.';
        default:
            return 'Your request could not be completed. Please try again.';
    }
}
